const formatTelephone = (value: string) => {
  return value?.split(" ").join("") ?? "";
}

export default formatTelephone;
